import React from 'react'
import {Card, Drawer, Form, Icon, notification, Button, Tooltip} from 'antd'
import _ from 'lodash'
import {connect} from 'react-redux'
import ReceiptsPDF from '../pdf/receiptsPDF'

import Request from '../../request'

class ReceiptsView extends React.Component {
    state = {
        visible: true,
        generatedReceipt: {},
    }

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    loadReceiptDetail = async() => {
        let params = {};
        params.sortField = 'createdDate'
        params.sortOrder = 'descend'
        let data = await Request.getTodaySubmittedReceipts()
        if(!data.error) {
            this.setState({generatedReceipts: data.data.receipts});
        }
    }

    componentWillMount() {
        this.loadReceiptDetail();
    }

    downloadReceipt = () => {
        var printContents = document.getElementById('table_with_data').innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
    }
    render() {
        const { generatedReceipts } = this.state;
        return (
            <Drawer
                title={
                    <div>
                        {'Receipt'} {' '}
                        <a onClick={this.onClose} style={{float: 'right', color: 'black'}}>
                            <Icon type={'close'}/>
                        </a>
                    </div>
                }
                placement="right"
                closable={false}
                onClose={this.onClose}
                width={1000}
                visible={this.state.visible}>
                <div>
                    <Tooltip title="Download Receipt ">
                        <Button
                            loading={false}
                            shape="circle"
                            icon="download"
                            onClick={() => {this.downloadReceipt()}}
                        />
                    </Tooltip>
                    <Card id='table_with_data'>                        
                        <ReceiptsPDF generatedReceipts={generatedReceipts} />
                    </Card>
                </div>
            </Drawer>
        )
    }
}
  
const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReceiptsView)